import React from "react";
import type {
  Contact,
  ContactValidation,
} from "../../../../application/domain/proc-management";
import ContactInput from "./contact-input";
import { ListInput } from "./list-input";
import type { InputProps, PathProps } from "./types";

const notices = ["手続きに関する問い合わせ先を列挙します。"];

type Props = InputProps &
  PathProps & {
    value: Contact[];
    isServiceProviderAccount: boolean;
    organizationId: string;
    validationErrors: ContactValidation[];
  };

export const ProcedureContactsListInput: React.FC<Props> = ({
  value,
  isServiceProviderAccount,
  organizationId,
  onChange,
  disabled = false,
  basePath,
  shouldDisplayError,
  validationErrors,
}) => {
  return (
    <ListInput
      label="問い合わせ先"
      component={ContactInput}
      componentProps={value.map((v, i) => ({
        ...v,
        orgId: organizationId,
        isServiceProviderAccount: isServiceProviderAccount,
        onChange,
        shouldDisplayError,
        validationErrors: validationErrors[i],
      }))}
      basePath={basePath}
      onPush={() => {
        onChange(basePath, [...value, {}]);
      }}
      onRemove={(i) => {
        onChange(basePath, [...value.slice(0, i), ...value.slice(i + 1)]);
      }}
      disabled={disabled}
      notices={notices}
    />
  );
};
